/** @format */

import React from "react";
import { useEffect } from "react";
import ReactSelect from "react-select";

const InputSelect = (props) => {
  const {
    setValues,
    label,
    placeholder,
    name,
    value,
    handleSelect,
    handelError,
    onChange,
    options,
  } = props;
  useEffect(() => {}, [props.value]);
  return (
    <div className='input__box'>
      <label htmlFor='en_name' className='input__label'>
        {label}
      </label>

      <ReactSelect
        options={options}
        name={name}
        onChange={onChange}
        value={options?.find(
          (option) => option.value === value || option.value === value?.value
        )}
      />
    </div>
  );
};

export default InputSelect;
